import _ from 'lodash'
import EventEmitter from 'eventemitter3'
// eslint-disable-next-line no-unused-vars
import { Resource, AudioResource } from './Resource'
import { AudioManager } from './AudioManager'
import Message from './Message'
import Player from './Player'
const axios = require('axios').default.create({
  headers: {
    Authorization: 'Basic rRQ62nVrXA2JZRq2'
  }
})
/**
 * @typedef {import('./Assistant').Assistant} Assistant
 */
/**
 * @typedef {import('./Scene').Scene} Scene
 */
/**
 * @typedef {import('./Screenplay').Screenplay} Screenplay
 */
/**
 * @typedef {import('./Message').Message} Message
 */
/**
 * @typedef {import('./Player').Player} Player
 */
/**
 * 用於操作遊戲的進行
 */
export class Game extends EventEmitter{
  /**
   * @param {Player} player
   * @param {Assistant} assistant
   */
  constructor(player, assistant){
    super()
    /**
     * 代表主要角色
     * @type {Player}
     */
    this.player = player
    /** @type {Player[]} */
    this.roles = []
    /** @type {Assistant} */
    this.assistant = assistant
    /** @type {AudioManager} */
    this.audioManager = AudioManager.instance
    this.audioManager.register(
      new AudioResource({
        id: 'typewriter',
        src: '/audios/typewriter.mp3'
      })
    )
    /** @type {Screenplay} */
    this.screenplay = null
    /**
     * 各劇本可自訂內容的命名空間
     * 同步時會上傳至雲端
     * @type {Object}
     */
    this.status = {}
    /**
     * 各劇本可自訂內容的命名空間
     * 同步時"不會"上傳至雲端
     * @type {Object}
     */
    this.local = {}
    /**
     * default: https://us-central1-andy-self-test.cloudfunctions.net/store/game
     * @type {string}
     */
    this.syncEndPoint = 'https://us-central1-andy-self-test.cloudfunctions.net/store/game'

    /** @type {Scene} */
    this.currentScene = null
    /** @type {Message} */
    this.currentMessage = null
    /** @type {Message[]} */
    this.history = []

    this.on('game-event', (data)=>{
      if(this.screenplay){
        this.screenplay.onEvent(this, data)
      }
    })
    let inputCounter = 0
    this.on('user-input', async (data)=>{
      if(this.screenplay){
        let msg = this.currentMessage
        let noPushHistory = false
        await this.screenplay.onInput(this, data)
        if(msg && msg.data.tips){
          let tips = msg.data.tips
          if(tips.round === 1){
            this.emit('tips-story-init', {
              type: 'tips-story-init',
              tips,
              message: msg,
              query: data.query
            })
          }
          if(!msg.data.tips.completed){
            noPushHistory = true
          }else{
            this.emit('tips-story-close', {
              type: 'tips-story-close',
              tips,
              message: msg,
              query: data.query
            })
          }
        }
        if(!noPushHistory){
          this.history.push(new HistoryRecord({
            type: 'user',
            data,
            scene: this.currentScene,
            message: new Message({
              id: '@@user-input-' + inputCounter,
              sender: '你',
              content: data.query
            }),
            info: msg.data
          }))
          inputCounter++
        }
      }
    })
    this.$speechAudio = new Audio()
    this.on('change-message', async (current, old)=>{
      // 如果有assistant就使用tts
      console.log('game:change-msg', current, old)
      // if(this.assistant){
      setTimeout(()=>{
        this.playMessageAudio(current)
      }, 0)
      // }
    })
  }
  async playMessageAudio(message, cb = ()=>{}){
    if(message.audio && message.audio.url){
      let speechAudio = this.$speechAudio
      document.getElementById('resources').appendChild(speechAudio)
      speechAudio.pause()
      speechAudio.src = message.audio.url
      speechAudio.messageTime = 0
      speechAudio.play()
    }else{
      if(!message.noTTS){
        if(!message.getTextContent()){
          message.splitContent()
        }
        this.assistant.startTTS(message.ssml || message.getTextContent())
      }
    }
  }
  /**
   * 設定目前的劇本
   * 並初始化場景
   * @param {Screenplay} screenplay
   * @param {string} sceneId
   * @param {string} messageId
   */
  installScreenplay(screenplay, sceneId = 'START', messageId = 'START'){
    if(this.screenplay){
      this.screenplay.onUninstall(this)
    }
    this.screenplay = screenplay
    this.changeScene(sceneId, messageId)
    this.screenplay.onInstall(this)
  }
  /**
   * 預載
   */
  async preloadResources(){
    await this.audioManager.preloadAll()
  }
  /**
   *
   * @param {string} key
   */
  uploadStatus(id){
    let datas = {
      id,
      datas: {
        status: this.status,
        player: this.player,
        roles: this.roles
      }
    }
    return axios.post(
      this.syncEndPoint + `/${id}`,
      datas
    ).then((res)=>{
      return res
    })
  }
  downloadStatus(id){
    const { Player } = require('./Player')
    return axios.get(
      this.syncEndPoint + `/${id}`
    ).then((res)=>{
      let datas
      let result
      if(res.data.data){
        datas = res.data.data.datas
        result = {
          status: datas.status,
          player: new Player(datas.player),
          roles: datas.roles.map((player)=>{
            return new Player(player)
          })
        }
      }else{
        result = {
          status: {},
          player: new Player(),
          roles: []
        }
      }
      return result
    })
  }
  /**
   * @param {{
   *  status: Object,
   *  player: Player,
   *  roles: Player[]
   * }} data
   */
  setupStatus(data){
    this.status = data.status
    this.player = data.player || new Player()
    this.roles = data.roles
  }
  /**
   *
   * @param {string} key
   */
  syncStatus(id){
    return this.downloadStatus(id)
      .then((data)=>{
        this.setupStatus(data)
      })
  }
  /**
   * 切換至下一則訊息
   *
   * (根據當前劇本的messages的順序)
   */
  nextMessage(opts = {}){
    if(this.currentScene){
      let i = this.currentScene.messages.findIndex((msg) => msg === this.currentMessage)
      if(this.currentScene.messages[i + 1]){
        this.changeMessage(this.currentScene.messages[i + 1].id, opts)
        return true
      }
    }
    return false
  }
  /**
   * @param {string} messageId
   * @returns {boolean} success
   */
  changeMessage(messageId, opts = {}){
    if(this.currentScene.messagesMap[messageId]){
      if(!opts.noHistory){
        setTimeout(()=>{
          let msg = this.currentMessage
          this.history.push(new HistoryRecord({
            scene: this.currentScene,
            message: new Message(_.merge({ _contentHtml: msg._contentHtml, content: msg.content }, msg))
          }))
        })
      }
      this.currentMessage = this.currentScene.messagesMap[messageId]
    }
    return !!this.currentScene.messagesMap[messageId]
  }
  /**
   * @param {string} sceneId
   * @param {string | null} messageId (default: 'START')
   * @returns {boolean} success
   */
  changeScene(sceneId, messageId = null, opts = {}){
    let scene = this.screenplay.scenes.find((scene) => scene.id === sceneId)
    if(scene){
      let msg = scene.messagesMap[messageId || 'START'] || scene.messages[0]
      if(msg){
        if(!opts.noHistory){
          setTimeout(()=>{
            let msg = this.currentMessage
            this.history.push(new HistoryRecord({
              scene: this.currentScene,
              message: new Message(_.merge({ _contentHtml: msg._contentHtml, content: msg.content }, msg))
            }))
          })
        }
        this.currentScene = scene
        this.currentMessage = msg
        return true
      }
    }
    return false
  }
  /**
   * changeScene 的 字串版
   *
   * 格式: <scene id>/<message id>
   *
   * 範例: 大廳/主角台詞1
   *
   * @param {string} messagePath
   */
  to(messagePath, opts = {}){
    let paths = messagePath.split('/')
    if(paths.length === 1){
      return this.changeMessage(paths[0], opts)
    }else if(paths.length === 2){
      return this.changeScene(paths[0], paths[1], opts)
    }else{
      throw new Error('messagePath 設定有誤')
    }
  }
  generateGameRecord(){
    let last = new HistoryRecord({
      scene: this.currentScene,
      message: this.currentMessage
    })
    return this.history.concat([last]).map((e)=>e.toSimpleRecord())
  }
}
export class HistoryRecord{
  /**
   * @param {HistoryRecord} opts
   */
  constructor(opts = {}){
    /**
     * @type {string} 'user' | 'system'
     */
    this.type = opts.type || 'system'
    this.message = opts.message
    this.scene = opts.scene
    this.info = opts.info
    if(!this.type || !this.message || !this.scene){
      // throw new Error('缺少必要欄位')
      console.warn('缺少必要欄位', this.type, this.message, this.scene)
    }
  }
  toSimpleRecord(){
    let obj = {
      type: this.type,
      msgId: this.message.id,
      msgType: this.message.type,
      content: this.message.content,
      sender: this.message.sender,
      scene: this.scene.id,
      info: this.info
    }
    return obj
  }
}
export default Game
